/** Prefijo de la marca "ya se mostró el aviso en esta sesión" (sessionStorage). */
const PREFIJO_MARCA = 'buzon-aviso-inicio:';

/** Condiciones que deciden si se muestra el aviso de pendientes al iniciar sesión. */
export interface CondicionesAvisoBuzon {
  autenticado: boolean;
  tieneBuzon: boolean;
  /** Mientras cargan los permisos no se sabe si el rol tiene buzón ni a dónde lo mandará el tablero. */
  permisosCargando: boolean;
  /** El cambio de contraseña (obligatorio o voluntario) va primero; el aviso espera. */
  cambioDeContrasenaAbierto: boolean;
  pendientes: number;
  rutaActual: string;
  yaMostrado: boolean;
}

/**
 * @function debeMostrarAvisoBuzon
 * @description M3-H1: "aviso al iniciar sesión cuando hay pendientes, que lleva al buzón". Se muestra
 * una sola vez por sesión, ya con los permisos cargados, sin encimarse al cambio de contraseña y no
 * estando ya en el buzón.
 */
export const debeMostrarAvisoBuzon = (c: CondicionesAvisoBuzon): boolean =>
  c.autenticado &&
  c.tieneBuzon &&
  !c.permisosCargando &&
  !c.cambioDeContrasenaAbierto &&
  !c.yaMostrado &&
  c.pendientes > 0 &&
  !c.rutaActual.startsWith('/buzon') &&
  !c.rutaActual.startsWith('/login');

/**
 * @function llaveSesionAvisoBuzon
 * @description Identifica la sesión sin guardar el token: usuario + expiración del token, que cambia
 * en cada inicio de sesión. Sin alguno de los dos no hay sesión que marcar.
 */
export const llaveSesionAvisoBuzon = (idUsuario: number, expiracion: string | null | undefined): string | null =>
  idUsuario > 0 && expiracion ? `${PREFIJO_MARCA}${idUsuario}:${expiracion}` : null;

/** Lee la marca; si el navegador bloquea sessionStorage, se considera no mostrado. */
export const avisoBuzonYaMostrado = (llave: string | null): boolean => {
  if (!llave) {
    return true;
  }
  try {
    return sessionStorage.getItem(llave) === '1';
  } catch {
    return false;
  }
};

/** Deja la marca; si sessionStorage no está disponible, el aviso puede repetirse al recargar. */
export const marcarAvisoBuzonMostrado = (llave: string | null): void => {
  if (!llave) {
    return;
  }
  try {
    sessionStorage.setItem(llave, '1');
  } catch {
    // Sin almacenamiento de sesión solo se pierde la marca; el aviso sigue funcionando.
  }
};
